<script>import { getContext } from 'svelte';
import HeaderRow from './HeaderRow.svelte';
import { twMerge } from 'tailwind-merge';
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from '../../actions';
export let use = [];
import { exclude } from '../../utils/exclude';
const forwardEvents = forwardEventsBuilder(get_current_component());
export let orderBy;
export let order = 'asc';
export let onColumnHeaderClick = undefined;
const header = getContext('table-header');
const columns = getContext('table-columns');
const scrollbarWidth = getContext('table-scrollbar-width');
header.set(true);
const defaultClass = 'flex-shrink table min-w-full border-separate border-spacing-0 table-fixed shadow-md bg-surface relative stwui-table-header-wrapper';
$: finalClass = twMerge(defaultClass, $$props.class);
</script>

<table
	class={finalClass}
	style="padding-right:{$scrollbarWidth}px"
	use:useActions={use}
	use:forwardEvents
	{...exclude($$props, ['use', 'class'])}
>
	<thead>
		<tr class="table-row">
			{#each columns as column, index}
				<HeaderRow
					classes="{index !== 0 ? 'hidden ' : ''}truncate md:table-cell"
					{column}
					columnCount={columns.length}
					{order}
					{orderBy}
					{onColumnHeaderClick}
				/>
			{/each}
		</tr>
	</thead>
</table>
